module.exports = __webpack_public_path__ + "static/media/Teil_2.cd220a73.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/Teil_2.ogv
// module id = 119
// module chunks = 0